import { render, staticRenderFns } from "./BenefitTypeEdit.vue?vue&type=template&id=3b019bbf&"
import script from "./BenefitTypeEdit.js?vue&type=script&lang=js&"
export * from "./BenefitTypeEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports